import { EventEmitter } from '../util/eventemitter';
import { GORef } from './goref';

export class GameObject extends EventEmitter {
    world: any;
    type: any;
    serverObjectIdx: number;
    position: any;
    ref: GORef;
    selected: boolean;
    pawn: any;

    constructor(objType: any, world: any) {
        super();
      this.world = world;
      this.type = objType;
      this.serverObjectIdx = -1;
      this.position = new THREE.Vector3(0, 0, 0);
      this.ref = new GORef(this);
      this.selected = false;
      this.pawn = undefined;
    }

    setPosition(x: any, y: any, z: any) {
      this.position.set(x, y, z);
      this.emit('moved');
    }

    dropFromSky() {
      const highZ = this.world.findHighPoint(this.position.x, this.position.y);
      this.position.z = highZ;
      this.emit('moved');
    }

    update(delta: any) {
      if (this.pawn) {
        this.pawn.setPosition(this.position);
        this.pawn.update(delta);
      }
    }

}

/**
 * @constructor
 */






